"use strict";

var _toConsumableArray = require("/root/website/node_modules/@babel/runtime/helpers/toConsumableArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaValue = exports.mq = void 0;

var _facepaint = _interopRequireDefault(require("facepaint"));

var medias = [280, 320, 960, 1200, 1440];

var toMinWidth = function toMinWidth(value) {
  return "@media(min-width: ".concat(value, "px)");
};

var mq = (0, _facepaint.default)(medias.map(toMinWidth));
exports.mq = mq;

var mediaValue = function mediaValue(mobileValue, desktopValue) {
  return [].concat(_toConsumableArray(Array(3).fill(mobileValue)), _toConsumableArray(Array(3).fill(desktopValue)));
};

exports.mediaValue = mediaValue;